import {
  Accordion,
  AccordionItem,
  Button,
  Tag,
  Text,
} from '@grupoboticario/flora-react';
import { BiDownload } from 'react-icons/bi';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/store.inteface';
import { downloadOneFilePortal, getPortalUrls } from 'utils/downloadUrls';
import { useState } from 'react';
import { Table } from './styles';

export function TablePortal({ files, selected, handleSelect }: any) {
  const { cpId, stores } = useSelector(
    (state: ApplicationState) => state.storesContext,
  );
  const [loading, setLoading] = useState<{ [key: string]: boolean }>({});

  const franchiseCode = stores.map(({ code }) => code).slice(0, 100);
  const codeString = JSON.stringify(franchiseCode);

  async function handleDownload(id: any) {
    try {
      setLoading(prev => ({ ...prev, [id]: true }));
      const filesUrl = await getPortalUrls(cpId, codeString, [id]);
      if (filesUrl) {
        filesUrl.map((item: any) => downloadOneFilePortal(item));
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(prev => ({ ...prev, [id]: false }));
    }
  }

  return (
    <Accordion collapsible type="single">
      <Table>
        {files?.response.map((file: any) => {
          return (
            <AccordionItem value={`${file.id}`} as="tbody" key={file.id}>
              <tr>
                <td aria-label="checkbox">
                  <input
                    key={file.id}
                    type="checkbox"
                    id={file.id}
                    value={file.id}
                    onChange={() => handleSelect(file.id)}
                    checked={selected.some(
                      selection => selection.id === file.id,
                    )}
                  />
                </td>
                <td style={{ paddingLeft: '2rem' }}>
                  <Text size="bodyMediumShort" title={file.title} isTruncated>
                    {file.title}
                  </Text>
                </td>
                <td>
                  <Text
                    size="bodyMediumShort"
                    title={file.fileType}
                    isTruncated
                  >
                    {file.fileType}
                  </Text>
                </td>
                <td>
                  <Text size="bodyMediumShort">
                    <Tag variant="assorted9" as="span">
                      {file.tag}
                    </Tag>
                  </Text>
                </td>
                <td>
                  <Button
                    aria-label="button-download"
                    onClick={() => handleDownload(file.id)}
                    has="iconOnly"
                    size="small"
                    hierarchy="tertiary"
                    icon={<BiDownload />}
                    isLoading={loading[file.id] || false}
                  />
                </td>
              </tr>
            </AccordionItem>
          );
        })}
      </Table>
    </Accordion>
  );
}
